import React from 'react'

const Footer = (props) => {
  return <div className="footer-container">Copyright © Accurate Converter 2021</div>
}

export default Footer
